// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"024757ea","512":"27c84fdc"}[chunkId] + ".chunk.css";
};